import React, { useState, useEffect, useRef } from "react";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { RiImageAddFill } from "react-icons/ri";
import { SuccessPopUp } from "../../CommonComponents/SuccessPopUp";

function UpdateCourier() {

    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');
    const navigate = useNavigate();

    const location = useLocation();
    const data = location.state;
    const [title, setTitle] = useState(data?.title);
    const [trackingUrl, setTrackingUrl] = useState(data?.trackingUrl);
    const content = {
        title: title,
        trackingUrl: trackingUrl,
    };
    const members = async (okId) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/courier/save`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                if (okId === 'ok') {
                    navToCat('/admin/courier');
                    setShowPop(false);
                } else if (okId === 'addMore') {
                    setShowPop(false);
                    setTitle('');
                    setTrackingUrl('');
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
                    });
                };

            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv();
                setExtraBtn();
                setMore("ok");
            }
        } catch (e) {
            console.log(e, 'error in member api')
        }
    };

    const [showPop, setShowPop] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();

    const [extraBtn, setExtraBtn] = useState();

    const onMoreBtn = () => {
        setShowPop(false);
        members("addMore");
        setNavv();
    };

    const navToCat = useNavigate();
    const confirmPopUp = () => {
        setShowPop(false);
        members("ok");
        setNavv("ok");
    };

    const onCloseBtn = () => {
        if (more === "OK") {
            navToCat("/admin/courier");
        } else {
            setAction('');
            setExtraBtn();
            setMore('cancel');
            setShowPop(false);
        }
    };

    const [errors, setErrors] = useState({});
    const titleRef = useRef(null);
    const bannerEnmRef = useRef(null);

    const handleValidation = () => {
        let newErrors = {};

        if (!title?.trim()) newErrors.title = "titel is required";
        if (!trackingUrl?.trim()) newErrors.bannerTypeEnum = "titel is required";

        setErrors(newErrors);

        // If there are errors, scroll to the first one
        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }

        return true;

    };

    const scrollToField = (field) => {
        switch (field) {
            case "title":
                titleRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "bannerTypeEnum":
                bannerEnmRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            setAction("Confirm submit");
            setShowPop(true);
            setNavv("OK");
            setExtraBtn("Add More");
            setMore("Cancel")
        }
    };

    const updateCou = async (uuid) => {
        console.log("run run")
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/courier/update/${uuid}`, {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': "application/json"
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction(getRes.message);
                setMore("OK");
                setShowPop(true);
                setNavv();
                setExtraBtn();
            } else {
                setAction(getRes.message);
                setMore("OK");
                setShowPop(true);
                setNavv();
                setExtraBtn();
            }
        } catch (e) {
            console.log(e, "error in courire")
        }
    }

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>{data ? "Update Courier" : "Add Courier"}</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form">
                            {/* NAME*/}
                            <div  ref={titleRef}>
                                <div className="add" style={{width:"100% "}}>
                                    <label style={errors.title && { color: "red" }}>Title</label>
                                    <input
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </div>
                                <div className="add parentid" style={{width:"100% "}} ref={bannerEnmRef}>
                                    <label style={errors.bannerTypeEnum && { color: "red" }}>Tracking URL</label>
                                    <input
                                        type="text"
                                        value={trackingUrl}
                                        onChange={(e) => setTrackingUrl(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn submit-btn">
                        <button onClick={() => data ? updateCou(data.uuid) : handleSubmit()}>{data ? "Update" : "Submit"}</button>
                    </div>
                </div>
            </div>

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
                moreBtn={extraBtn}
                onMoreBtn={onMoreBtn}
            />
        </>
    )
}
export default UpdateCourier;